import React from 'react';
import { GoogleFilesPanel } from './GoogleFilesPanel';
import { Table2 } from 'lucide-react';
export function GoogleSheetsPanel() {
  return <GoogleFilesPanel title="Google Sheets" description="Hojas de cálculo, reportes y datos compartidos del equipo." mimeType="application/vnd.google-apps.spreadsheet" icon={<Table2 size={24} data-id="element-4890" />} colorClass="text-emerald-400" bgClass="bg-emerald-500/10" borderClass="border-emerald-500/20" glowClass="bg-emerald-500/10" data-id="element-4889" />;
}